import React, { useState, useEffect } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Table,
  Modal,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import toast, { Toaster } from "react-hot-toast"
import ReactPaginate from "react-paginate"
import { addData } from "Servicescalls"
import { imgUrl } from "Baseurls"

const Eventgallery = () => {
  const [modal_small, setmodal_small] = useState(false)

  function tog_small() {
    setmodal_small(!modal_small)
    removeBodyCss()
  }

  const [Files, setFiles] = useState({ profile_pic: "" })

  const changeHandler = e => {
    const file = e.target.files
    var ext = file[0].name.split(".").pop()
    var type = ext
    if (
      type == "jpg" ||
      type == "jpeg" ||
      type == "png" ||
      type == "JPG" ||
      type == "JPEG" ||
      type == "PNG"
    ) {
      setFiles(e.target.files)
    } else {
      e.target.value = null
      toast.error("Please select a valid image file (jpg, jpeg, or png)")
    }
  }

  const [User, setUser] = useState([])
  const [form, setform] = useState([])

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }

  const GetAll = async () => {
    const resonse = await addData("deliveryBoy/list")
    var _data = resonse
    setUser(_data.data.data)
  }

  const Add = async () => {
    const dataArray = new FormData()
    const formid = form._id
    dataArray.append("firstname", form.firstname)
    dataArray.append("email", form.email)
    dataArray.append("phone", form.phone)
    dataArray.append("password", form.password)
    dataArray.append("salary", form.salary)
    dataArray.append("status", form._id == undefined || form._id == null?"active": form.status)
    for (let i = 0; i < Files.length; i++) {
      dataArray.append("profile_pic", Files[i])
    }

    try {
      const newapipath = formid
        ? "deliveryBoy/edit/" + formid
        : "deliveryBoy/create"
      const resonse = await addData(newapipath, dataArray)
      var _data = resonse
      setform(
        {
          firstname: "",
          email: "",
          phone: "",
          password: "",
          status: "",
        },
        setFiles({
          profile_pic: "",
        })
      )
      toast.success(_data.data.message)
      setmodal_small(false)
      GetAll()
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }
  }

  const getpopup = data => {
    setform(data)
    tog_small()
  }
  const getpopup1 = ()  => {
    setform([])
    tog_small()
  }

  const handleSubmit = e => {
    e.preventDefault()
    Add()
  }

  const deletebenners = async data => {
    try {
      const resonse = await addData("category/deleteCategory", {
        category_id: data._id,
      })
      var _data = resonse
      toast(_data.data.message)
      GetAll()
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      deletebenners(data)
    }
  }

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = User.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(User.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  useEffect(() => {
    GetAll()
  }, [])

  const [search, setsearch] = useState([])

  const searchAll = async e => {
    let myUser = { ...search }
    myUser[e.target.name] = e.target.value
    setsearch(myUser)
    const resonse = await addData(
      "deliveryBoy/list?searchQuery=" + e.target.value
    )
    var _data = resonse
    setUser(_data.data.data)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Hasini Enterprises"
            breadcrumbItem="Delivery Boys"
          />
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md="6">
                      <Button
                        color="primary"
                        onClick={() => {
                          getpopup1()
                        }}
                      >
                        <i className="bx bx-plus-circle" /> Add Delivery Boy
                      </Button>
                    </Col>
                    <Col md="6">
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          className="form-control"
                          placeholder="Search.."
                          value={search.search}
                          onChange={searchAll}
                          name="search"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div>
                    <div className="table-responsive">
                      <Table className="table table-bordered mb-4 mt-3">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Profile</th>
                            <th>Salary</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((data, key) => (
                            <tr key={key}>
                              <td>{(pageNumber - 1) * 5 + key + 6}</td>
                              <td>{data.firstname} </td>
                              <td>{data.email}</td>
                              <td>{data.phone} </td>
                              <td>
                                <img
                                  style={{ width: "70px" }}
                                  src={imgUrl + data.profile_pic}
                                />
                              </td>
                              <td>₹ {data.salary}</td>
                              <td
                                className={data.status == "active"
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {data.status}
                              </td>
                              <td>
                                <Button
                                  onClick={() => {
                                    getpopup(data)
                                  }}
                                  className="mr-2"
                                  style={{ padding: "6px", margin: "3px" }}
                                  color="success"
                                  outline
                                >
                                  <i className="bx bx-edit"></i>
                                </Button>
                                {/* <Button
                                  onClick={() => {
                                    manageDelete(data)
                                  }}
                                  style={{ padding: "6px", margin: "3px" }}
                                  color="danger"
                                  outline
                                >
                                  <i className="bx bx-trash"></i>
                                </Button> */}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          size="lg"
          centered
          isOpen={modal_small}
          toggle={() => {
            tog_small()
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              {form._id == undefined || form._id == null ? "Add" : "Edit"}{" "}
              Delivery Boy
            </h5>
            <button
              onClick={() => {
                setmodal_small(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              onSubmit={e => {
                handleSubmit(e)
              }}
            >
              <Row>
                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Name"
                      required
                      name="firstname"
                      value={form.firstname}
                      onChange={e => {
                        handleChange(e)
                      }}
                    />
                  </div>
                </Col>
                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Email <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="email"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Email"
                      required
                      name="email"
                      value={form.email}
                      onChange={e => {
                        handleChange(e)
                      }}
                    />
                  </div>
                </Col>
                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Phone No <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Phone No"
                      required
                      name="phone"
                      value={form.phone}
                      onChange={e => {
                        handleChange(e)
                      }}
                    />
                  </div>
                </Col>
                 {form._id == undefined || form._id == null ? (
                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Password
                      {form._id == undefined || form._id == null ? (
                        <span className="text-danger">*</span>
                      ) : (
                        ""
                      )}
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Password"
                      required={form._id == undefined || form._id == null}
                      name="password"
                      value={form.password}
                      onChange={e => {
                        handleChange(e)
                      }}
                    />
                  </div>
                </Col>
                 ) : (
                        ""
                      )}

                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Profile
                      {form._id == undefined || form._id == null ? (
                        <span className="text-danger">*</span>
                      ) : (
                        ""
                      )}
                    </Label>
                    <Input
                      type="file"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      required={form._id == undefined || form._id == null}
                      name="profile_pic"
                      value={Files.profile_pic}
                      onChange={changeHandler}
                    />
                  </div>
                </Col>

                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Salary <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Salary"
                      required
                      name="salary"
                      value={form.salary}
                      onChange={e => {
                        handleChange(e)
                      }}
                    />
                  </div>
                </Col>
                {form._id == undefined || form._id == null ? (
                  ""
                ) : (
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Status <span className="text-danger">*</span>
                      </Label>
                      <select
                        className="form-select"
                        required
                        name="status"
                        value={form.status}
                        onChange={e => {
                          handleChange(e)
                        }}
                      >
                        <option value="">Select Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </Col>
                )}
              </Row>
              <div style={{ float: "right" }}>
                <Button
                  onClick={() => {
                    setmodal_small(false)
                  }}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="success" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>

        <Toaster />
      </div>
    </React.Fragment>
  )
}

export default Eventgallery
